export const NO_EDUCATOR_SUBSCRIPTION_INTEGRATIONS = {
  HubSpot: false,
  'Customer.io': false,
};

// Default integrations options to send for the analytics.identify and analytics.track call
// By default we don't send identify or track to vero to save costs. JIRA PLAN-1613
export const DEFAULT_INTEGRATIONS = {
  All: true,
  Vero: false,
};
